import React, { FC } from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../../theme';
import { CdnIcon } from '@shared/ui';
import { IconButton } from '../../../../../../BaseComponents';
import { WithTooltip } from '@shared/ui/WithTooltip';

interface Props {
	className?: string;
	name: string;
	error?: string;
	onClick?: () => void;
	onDelete?: () => void;
}

const UploadedFile: FC<Props> = ({ className, name, error, onClick, onDelete }) => {
	const { UploadedFile: css } = useTheme('Shared').FileUpload;

	return (
		<div className={cn(css.root, className, { [css.pointer]: !!onClick, [css.error]: !!error })}>
			<WithTooltip title={error}>
				<div className={css.leftBlock} onClick={onClick}>
					<CdnIcon className={css.iconFile} icon={!!error ? 'Info/Not included' : 'Document/File'} />

					<span className={css.name}>{name}</span>
				</div>
			</WithTooltip>

			{!!onDelete && (
				<IconButton
					classes={{
						root: css.iconButton
					}}
					onClick={onDelete}
				>
					<CdnIcon icon="Action/Remove" className={css.removeIcon} />
				</IconButton>
			)}
		</div>
	);
};

export default UploadedFile;
